// extracted by mini-css-extract-plugin
module.exports = {"header":"header___2HJqf","top-layer":"top-layer___2FBtL","tabs":"tabs___3tluo"};